/**
 * Guest cart — persisted in localStorage so unauthenticated users can browse
 * and add items without being forced to sign in.
 *
 * Shape: [{ product_id, quantity, product }]
 *
 * On sign-in the cart is merged into the real backend cart via mergeGuestCart().
 */

const KEY = 'rivora_guest_cart';

export function getGuestCart() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '[]');
  } catch {
    return [];
  }
}

export function saveGuestCart(items) {
  localStorage.setItem(KEY, JSON.stringify(items));
}

export function clearGuestCart() {
  localStorage.removeItem(KEY);
}

/**
 * Add or increment an item in the guest cart.
 * Returns the updated cart.
 */
export function addToGuestCart(product, quantity = 1) {
  const cart = getGuestCart();
  const existing = cart.find(i => i.product_id === product.product_id);
  if (existing) {
    existing.quantity += quantity;
  } else {
    cart.push({ product_id: product.product_id, quantity, product });
  }
  saveGuestCart(cart);
  return cart;
}

/** Total item count across all lines */
export function guestCartCount() {
  return getGuestCart().reduce((sum, i) => sum + i.quantity, 0);
}
